/**
 * Hover-open for Dawn's <header-menu> desktop dropdowns.
 *
 * Dawn uses <details>/<summary> inside each <header-menu> custom element.
 * Setting the `open` attribute directly (instead of a click) is the only
 * reliable cross-browser way to open them, because modern Chrome and Safari
 * hide the disclosure content via internal UA rendering that CSS cannot override.
 *
 * A short close-delay (CLOSE_DELAY ms) lets the cursor travel from the
 * trigger into the dropdown without it snapping shut.
 */

(function () {
  var CLOSE_DELAY = 120; // ms

  function initHoverMenus() {
    // Only wire hover on non-touch devices — touch users tap, not hover.
    if (window.matchMedia('(hover: none)').matches) return;

    var menus = document.querySelectorAll('header-menu');
    if (!menus.length) return;

    menus.forEach(function (menu) {
      var details = menu.querySelector('details');
      var summary = details && details.querySelector('summary');
      if (!details || !summary) return;

      var closeTimer = null;

      function openMenu() {
        clearTimeout(closeTimer);
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
      }

      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      }

      menu.addEventListener('mouseenter', openMenu);
      menu.addEventListener('mouseleave', scheduleClose);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenus);
  } else {
    initHoverMenus();
  }
})();